(function () {
  if (window.blogSidebarInitialized) return;
  window.blogSidebarInitialized = true;

  let subscribeWrapper = document.querySelector(".subscribe-to-blog");
  let subscribeBtn = document.querySelector(".subscribe-button");

  if (subscribeWrapper && subscribeBtn) {
    subscribeBtn.addEventListener("click", () => {
      subscribeWrapper.classList.toggle("opened");
    });
  }

  let copyBtn = document.querySelector(".copy-to-clipboard .copy");
  let copyLink = document.querySelector(".copy-to-clipboard .link");

  if (copyBtn && copyLink) {
    let copyText = copyLink.getAttribute("href");

    copyBtn.addEventListener("click", () => {
      navigator.clipboard.writeText(`${copyText}`);
      copyBtn.classList.add("copied");
      setTimeout(() => {
        copyBtn.classList.remove("copied");
      }, 3000);
    });
  }
})();
